<template>
    <div>
        <CommonPopupFrame :changeBottom="0" :changeHeight="90" :isOpen="isOpen" :closeCompleteAction="() => { closeCompleteAction(PROFILE_BOX_LIST.USE_REASONS, true, false, false) }">
            <div style="width: 36px; height: 5px; background-color: #d9d9d9; margin: 0 auto; border-radius: 5px; margin-top: 5px"></div>
            <div @click="closeCompleteAction(PROFILE_BOX_LIST.USE_REASONS, true, false, false)" style="padding-left: 12px; margin-top: 6px; font-weight: 700; color: #808080; height: 30px; width: 50px;">닫기</div>
            <div @touchmove.stop="() => { }" style="margin-top: 31px; flex: 1; overflow-y: scroll; padding: 0 12px; padding-bottom: 20px;">
                <div style="text-align: center;">
                    <div style="font-weight: 700; font-size: 32px; line-height: 46px;">이용 목적</div>
                    <div style="margin-top: 15px; font-weight: 500; line-height: 24px;">사커하우를 사용하는 이유나 자주 사용하는<br>기능을 한 가지 선택할 수 있습니다</div>
                </div>
                <div style="display: flex; flex-wrap: wrap; gap: 12px; margin-top: 40px;">
                    <div @click="setUseReason(each)" :class="selectUseReason === each ? 'active' : ''" v-for="each, i in useReasonList" :key="i" style="padding: 12px 20px; border-radius: 24px; line-height: 24px; font-weight: 500; text-align: center; border: 1px solid #d9d9d9; font-size: 14px;">
                        {{ each }}
                    </div>
                </div>
            </div>
            <div style="height: 90px; padding: 0 12px;">
                <div @click="save" v-if="selectUseReason !== ''" class="save_btn_active">저장하기</div>
                <div v-else class="save_btn_unactive">저장하기</div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'
import ResponseCode from '../../ResponseCode'
import { PROFILE_BOX_LIST } from '@/Constants'

export default {
    name: 'SettingUseReason',
    components: { CommonPopupFrame },
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        closeCompleteAction: {
            type: Function,
            default: () => { },
        },
    },
    data() {
        return {
            selectUseReason: '',
            useReasonList: ['스터디', '매치', '용병', '조기축구', '축구선수 희망', '축구 진로 상담', '축구 수업', '1:1 수업', '팀원 스카웃', '축구 경기 관람', '축구 꿀팁 얻기', '축구 기술 익히기', '축구팀 개설', '학교 축구팀'],
            PROFILE_BOX_LIST: PROFILE_BOX_LIST
        }
    },
    methods: {
        setUseReason(reason) {
            this.selectUseReason = reason
        },
        async save() {
            if (this.selectUseReason === '') {
                this.$GlobalStore.showAlert('이용 목적을 선택 해주세요.');
                return;
            }
            this.$GlobalStore.showProgress()

            const formData = new FormData()
            formData.append('use_reasons', this.selectUseReason)

            const res = await this.$Axios.post('/api/profile/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } });

            if (res.data.code === ResponseCode.SUCCESS) {
                this.selectUseReason = ''
                this.$GlobalStore.hideProgress()
                this.closeCompleteAction(PROFILE_BOX_LIST.USE_REASONS, true, false, true)
            }
        }
    },
    watch: {
        isOpen(newVal) {
            if (!newVal) {
                this.selectUseReason = ''
            }
        }
    },
    created() {
        this.save = this.$Once(this.save)
    }
}
</script>

<style scoped>
.common_box {
    padding: 10px;
    border-radius: 12px;
    background-color: #f5f5f5;
    margin-top: 40px;
}

.save_btn_active {
    height: 48px;
    line-height: 48px;
    border-radius: 12px;
    background-color: #210f03;
    text-align: center;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    margin-top: 12px;
}

.save_btn_unactive {
    height: 48px;
    line-height: 48px;
    border-radius: 12px;
    background-color: #f5f5f5;
    text-align: center;
    color: #d9d9d9;
    font-size: 14px;
    font-weight: 500;
    margin-top: 12px;
}

.active {
    background-color: #210f03;
    color: #fff;
}
</style>